<div [style.--condition-columns]="columns()" [ngClass]="{ fh: settingsManager.settings.fhStyle }">
  <div class="condition-container">
    @for (condition of conditions | trackUUID; track condition._trackUUID; let i = $index) {
      <a
        class="item"
        [ngClass]="{
          disabled:
            (!hasCondition(condition) &&
              ((!immunityEnabled && isImmune(condition.name) && !permanentEnabled && !isPermanent(condition.name)) ||
                isImmune(condition.name, true))) ||
            (expireEnabled && !condition.types.includes(ConditionType.expire))
        }"
      >
        @if (condition.types.includes(ConditionType.stack) || condition.types.includes(ConditionType.upgrade)) {
          <img tabclick (click)="dec(condition)" class="ghs-svg dec" src="./assets/images/left.svg" />
        }
        <span
          class="condition"
          tabclick
          (click)="toggleCondition(condition)"
          [ghs-tooltip]="'game.condition.' + condition.name + '.hint'"
          [originX]="'center'"
          [overlayX]="'center'"
          [originY]="'top'"
          [overlayY]="'bottom'"
          [ngClass]="{
            active: (!immunityEnabled && hasCondition(condition)) || (immunityEnabled && immunities.includes(condition.name)),
            immunity: isImmune(condition.name)
          }"
        >
          <img [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/condition/' + condition.name + '.svg'" />
          @if (condition.types.includes(ConditionType.stack)) {
            <span [ngClass]="{ stack: true }" class="value">{{ getValue(condition) | ghsValueSign }}</span>
          }
          @if (condition.types.includes(ConditionType.upgrade)) {
            <span class="value">{{ getValue(condition) }}</span>
          }
        </span>
        @if (!isTrapEntity && isPermanent(condition.name)) {
          <span class="condition permanent permanent-overlay"></span>
        }
        @if (!isTrapEntity && isRoundExpire(condition.name)) {
          <span class="condition round round-overlay"></span>
        }
        @if (!isTrapEntity && isExpire(condition.name)) {
          <span class="condition expire expire-overlay"></span>
        }
        @if (condition.types.includes(ConditionType.stack) || condition.types.includes(ConditionType.upgrade)) {
          <img tabclick (click)="inc(condition)" class="ghs-svg inc" src="./assets/images/right.svg" />
        }
      </a>
      @if (conditionSeparator.includes(i)) {
        <div class="separator"></div>
      }
    }

    @if (conditions.length && !isTrapEntity) {
      <div class="separator"></div>
      <a class="item">
        <span
          class="condition toggle"
          [ngClass]="{ active: permanentEnabled }"
          tabclick
          (click)="togglePermanentEnabled()"
          [ghs-tooltip]="'game.condition.permanent.hint'"
          [originX]="'center'"
          [overlayX]="'center'"
          [originY]="'top'"
          [overlayY]="'bottom'"
        >
          <img src="./assets/images/condition/permanent.svg" />
        </span>
      </a>
      <a class="item">
        <span
          class="condition toggle"
          [ngClass]="{ active: roundExpireEnabled }"
          tabclick
          (click)="toggleRoundExpireEnabled()"
          [ghs-tooltip]="'game.condition.roundExpire.hint'"
          [originX]="'center'"
          [overlayX]="'center'"
          [originY]="'top'"
          [overlayY]="'bottom'"
        >
          <img src="./assets/images/condition/round.svg" />
        </span>
      </a>
      <!--
    <a class="item">
      <span class="condition toggle" [ngClass]="{'active': expireEnabled}" tabclick (click)="toggleExpireEnabled()"
        [ghs-tooltip]="'game.condition.expire.hint'" [originX]="'center'" [overlayX]="'center'" [originY]="'top'"
        [overlayY]="'bottom'">
        <img src="./assets/images/condition/expire.svg" />
      </span>
    </a>
    -->
      <a class="item">
        <span
          class="condition toggle"
          [ngClass]="{ active: immunityEnabled }"
          tabclick
          (click)="toggleImmunityEnabled()"
          [ghs-tooltip]="'game.condition.immune.hint'"
          [originX]="'center'"
          [overlayX]="'center'"
          [originY]="'top'"
          [overlayY]="'bottom'"
        >
          <img [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh/condition/immune.svg' : '/condition/immunity.svg')"
        /></span>
      </a>
    }
  </div>
</div>
